import { LinkDeviceComponent } from './link-device/link-device.component';
import { DeviceDeactivatedComponent } from './device-deactivated/device-deactivated.component';
import { DeviceNeedsToBeLinkedComponent } from './device-needs-to-be-linked/device-needs-to-be-linked.component';
import { AuthenticationRoutingModule } from '@stockcare-views/authentication/authentication-routing.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CryptoService } from '@stockcare-services/crypto/crypto.service';
import { AlertModule } from 'ngx-bootstrap/alert';
import { CreatePinComponent } from '@stockcare-views/authentication/create-pin/create-pin.component';
import { LoginContainerComponent } from '@stockcare-views/authentication/login-container/login-container.component';
import { LoginPinComponent } from '@stockcare-views/authentication/login-pin/login-pin.component';
import { LoginComponent } from '@stockcare-views/authentication/login/login.component';
import { LogoutComponent } from '@stockcare-views/authentication/logout/logout.component';
import { LogoutConfirmationComponent } from '@stockcare-views/authentication/logout/logout-confirmation/logout-confirmation.component';
import { SharedComponentsModule } from '@stockcare-components/shared-components.module';
import { DesktopLoginPinComponent } from './desktop-login-pin/desktop-login-pin.component';
import { PinComponent } from './pin/pin.component';
import { RemoveUserConfirmDialogComponent } from './login-pin/remove-user-confirm-dialog/remove-user-confirm-dialog.component';

@NgModule({
  imports: [
    AuthenticationRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AlertModule,
    SharedComponentsModule,
    CommonModule,
  ],
  declarations: [
    LoginContainerComponent,
    LoginComponent,
    LoginPinComponent,
    LinkDeviceComponent,
    CreatePinComponent,
    DeviceDeactivatedComponent,
    DeviceNeedsToBeLinkedComponent,
    LogoutComponent,
    LogoutConfirmationComponent,
    DesktopLoginPinComponent,
    PinComponent,
    RemoveUserConfirmDialogComponent,
  ],
  providers: [CryptoService],
})
export class AuthenticationModule {}
